<template>
    <div class="card">
        <div class="card-body">
            <div v-if="connectedPms === null">
                Loading..
            </div>
            <div class="mb-5" v-else-if="connectedPms.length > 0">
                <p>{{ __('You have connected with') }} {{ ucFirst(connectedPms[0].connectionType) }}.</p>
                <button class="btn btn-danger" @click="deletePmsConnection(connectedPms[0])">DELETE</button>
            </div>
            <div v-else class="steps d-flex mb-5 justify-content-between align-items-center">
                <div>
                    <div><strong>{{ __('Select your PMS') }}</strong></div>
                    <select v-model="selectedPms">
                        <option :value="pms" v-for="pms in availablePmsSystems" :key="pms">{{ ucFirst(pms) }}</option>
                    </select>
                </div>
                <div v-if="selectedPms == 'pushtech' || selectedPms == 'hotelizer'">
                    <div class="mb-2 d-flex align-items-center justify-content-between">
                        <strong class="mr-2">{{ __('Account ID') }}</strong>
                        <input type="text" class="form-control survey-settings-input" v-model="connectionName" />
                    </div>
                    <div class="mb-2 d-flex align-items-center justify-content-between">
                        <strong class="mr-2">{{ __('Secret') }}</strong>
                        <input type="text" class="form-control survey-settings-input" v-model="connectionPassword" />
                    </div>
                </div>
                <div v-else-if="selectedPms == 'hoteliga' || selectedPms == 'eurotel'">
                    <div class="mb-2 d-flex align-items-center justify-content-between">
                        <strong class="mr-2">{{ __('Username') }}</strong>
                        <input type="text" class="form-control survey-settings-input" v-model="connectionName" />
                    </div>
                    <div class="mb-2 d-flex align-items-center justify-content-between">
                        <strong class="mr-2">{{ __('Password') }}</strong>
                        <input type="text" class="form-control survey-settings-input" v-model="connectionPassword" />
                    </div>
                    <div class="mb-2 d-flex align-items-center justify-content-between">
                        <strong class="mr-2">{{ __('Domain') }}</strong>
                        <input type="text" class="form-control survey-settings-input" v-model="connectionDomain" />
                    </div>
                    <div v-if="selectedPms == 'eurotel'" class="d-flex align-items-center justify-content-between">
                        <strong class="mr-2">{{ __('Report ID') }}</strong>
                        <input type="text" class="form-control survey-settings-input" v-model="connectionExtraData" />
                    </div>
                </div>
                <div>
                    <button v-show="selectedPms" :disabled="!filled || saving" class="btn btn-primary"
                        @click="saveConnection">
                        {{ saving ? 'Saving...' : 'Save connection' }}
                    </button>
                </div>
            </div>
            <div class="not-found">
                <strong>{{ __("Can't find your PMS in the list?") }}</strong>
                <p>
                    {{ __("If you can't find your PMS in the list, please contact us at") }}
                    <a class="blue-text" href="mailto:support@guestflip.io">support@guestflip.io</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import SurveysService from "../../services/surveys-service";

export default {
    computed: {
        filled() {
            switch (this.selectedPms) {
                case "hoteliga":
                    if (
                        this.connectionName.length > 0 &&
                        this.connectionPassword.length > 0 &&
                        this.connectionDomain.length > 0
                    ) {
                        return true;
                    }
                    break;
                case "eurotel":
                    if (
                        this.connectionExtraData.length > 0 &&
                        this.connectionName.length > 0 &&
                        this.connectionPassword.length > 0 &&
                        this.connectionDomain.length > 0
                    ) {
                        return true;
                    }
                    break;
                case "pushtech":
                case "hotelizer":
                    if (
                        this.connectionName.length > 0 &&
                        this.connectionPassword.length > 0
                    ) {
                        return true;
                    }
                    break;
                default:
                    return false;
            }
            return false;
        }
    },
    mounted() {
        this.updatePmsConnections();
    },
    data() {
        return {
            connectedPms: null,
            availablePmsSystems: ["hoteliga", "pushtech", "hotelizer", "eurotel"],
            selectedPms: null,
            connectionName: "",
            connectionPassword: "",
            connectionDomain: "",
            connectionExtraData: "",
            saving: false
        };
    },
    methods: {
        async saveConnection() {
            if (!this.filled) {
                return;
            }
            this.saving = true;
            await SurveysService.settings.storePmsConnection(
                this.selectedPms,
                this.connectionName,
                this.connectionPassword,
                this.connectionDomain,
                this.connectionExtraData
            );
            this.selectedPms = null;
            this.connectionName = "";
            this.connectionPassword = "";
            this.connectionDomain = "";
            this.saving = false;
            this.updatePmsConnections();
        },
        async updatePmsConnections() {
            this.connectedPms = null;
            this.connectedPms = await SurveysService.settings.getPmsConnections();
        },
        async deletePmsConnection(connection) {
            await SurveysService.settings.deletePmsConnection(connection.id);
            this.updatePmsConnections();
        }
    }
};
</script>
